import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {localStorageKeys, sdoNs, pages} from '../constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '@modules/i18n';
import {routerInstance} from '@aofl/router';
import './sdo';
import {AnalyticEvent, AnalyticsTrackerQueue} from '@epg/epg-components';

/**
 * @summary LocaleDd
 * @extends {AoflElement}
 */
@customElement('locale-dd')
class LocaleDd extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of LocaleDd.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'locale-dd';
  @property({type: Object, attribute: false, mapState: `${sdoNs.LOCALE_DD}.selected`, store: storeInstance})
  selectedLanguage = {};

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.loggedIn`, store: storeInstance})
  loggedIn = false;

  @property({type: Array, mapState: `${sdoNs.LOCALE_DD}.$supportedLanguages`, store: storeInstance})
  supportedLangs = [];

  async toggleLanguage(e) {
    const selected = Object.assign({}, this.supportedLangs.find((item) => item.code === e.currentTarget.dataset.lang));
    storeInstance.commit({
      namespace: sdoNs.LOCALE_DD,
      mutationId: 'setSelected',
      payload: selected
    });
    document.documentElement.setAttribute('lang', selected.code);
    localStorage.setItem(localStorageKeys.LANG, selected.code);

    //Track change language event
    const event = AnalyticEvent.create('system.language_toggle', {
      selected_language: selected.code,
    });

    await AnalyticsTrackerQueue.enqueueEvent(event);

    const isParentRedeemPage = routerInstance.currentRoute.to.startsWith(pages.PARENT_REDEEM);
    if (isParentRedeemPage) {
      const url = pages.PARENT_REDEEM + selected.code + '/';
      routerInstance.navigate(url, {forceReload: true});
    } else {
      window.location = routerInstance.currentRoute.to;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.setSelected();
  }

  setSelected() {
    const state = storeInstance.getState();
    const globalLang = document.documentElement.getAttribute('lang');
    const selected = Object.assign({}, state[sdoNs.LOCALE_DD].supportedLangs.find((item) => item.code === globalLang));
    storeInstance.commit({
      namespace: sdoNs.LOCALE_DD,
      mutationId: 'setSelected',
      payload: selected
    });
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default LocaleDd;
